import React, { useState, useEffect } from "react";

import workflowService from "../../services/candidateLookupWorkflowService";
import CandidatesList from "./CandidatesList";
import { recordError } from "../../utils/logService";

const NysView = () => {

    const [defaultStatus, setDefaultStatus] = useState();
    const [statusData, setStatusData] = useState();
    const [statuses, setStatuses] = useState([]);

      useEffect(() => {
        getPlacementStatus();
      }, []);

    const getPlacementStatus = async () => {
        try {
          const response = await workflowService.getPlacementStatus();
          var statusData = [];
          if (response && response.status == 200) {
            const { data } = response;
            data.sort((a, b) => a.key - b.key);
            statusData = data.map((status) => ({
              key: status.key.toString(),
              label: status.value,
              children: "",
            }));  

            setStatuses(statusData);
            const defaultStatus = data.find((c) => c.value === "Submitted");

            setDefaultStatus(defaultStatus)
            // submittedStatus = defaultStatus.key;
            // setActiveKey(defaultStatus.key);
            
            //   "DATA OUT",
            //   statusData.find((c) => c.label === "Submitted")
            // );
    
            // setStatuses(statusData);
          } else {
            // setSelectedStatus([]);
          }
        } catch (error) {
          recordError(error);
        }
      };


  return (
    <div>
      {defaultStatus ? <CandidatesList statuses={statuses} defaultStatus={defaultStatus}/>: ""}
      </div>
  )
}


export default NysView;